import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import cn from 'classnames';
import ServiceDetails from '../ServiceDetails/ServiceDetails';
import styles from './ServicePanel.module.scss';
/**
 * @deprecated Use `useTestIds` instead
 */ export const getTestId = (idx)=>"service-panel-".concat(idx, "-");
const ServicePanel = /*#__PURE__*/ forwardRef(function ServicePanel(props, ref) {
    const { idx, footer, error } = props, rest = _object_without_properties(props, [
        "idx",
        "footer",
        "error"
    ]);
    const testId = getTestId(idx);
    return /*#__PURE__*/ _jsxs("div", {
        ref: ref,
        "data-testid": "".concat(testId, "container-").concat(idx),
        "aria-invalid": error,
        className: cn(styles.mainContainer, {
            [styles.error]: error
        }),
        children: [
            /*#__PURE__*/ _jsx(ServiceDetails, _object_spread_props(_object_spread({}, rest), {
                testId: testId,
                error: error
            })),
            /*#__PURE__*/ _jsx("div", {
                className: styles.footer,
                children: footer
            })
        ]
    });
});
export default ServicePanel;
